import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CountdownTimer from '../../components/feature/CountdownTimer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/c591fd864e84d1b12ca7fa30b9ee3f83.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                Girişimcilik Kitap Okuma 
                <span className="text-yellow-400"> Yarışması</span>
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-gray-200">
                Toplam <span className="text-yellow-400 font-bold">5 Milyon TL</span> değerinde ödüllerle 
                girişimcilik ruhunuzu geliştirin!
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/register">
                  <Button size="lg" className="w-full sm:w-auto">
                    <i className="ri-user-add-line mr-2"></i>
                    Hemen Kayıt Ol!
                  </Button>
                </Link>
                <Link to="/prizes">
                  <Button variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-gray-900">
                    <i className="ri-gift-line mr-2"></i>
                    Ödülleri Gör
                  </Button>
                </Link>
              </div>
            </div>
            
            <div className="flex justify-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-md">
                <CountdownTimer />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Alt Banner Section */}
      <section className="py-0">
        <div className="w-full">
          <img 
            src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/9f318b7670cb56885191949615b81d48.jpeg"
            alt="Girişimcilik Kitap Okuma Yarışması - Toplam 1.000 Kişiye 5 Milyon TL Değerinde Ödül"
            className="w-full h-auto object-cover object-top"
          />
        </div>
      </section>

      {/* Quick Info Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              Yarışma Hakkında
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Girişimcilik kitabını okuyun, sınavda başarılı olun ve hayalinizdeki ödülü kazanın!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-book-open-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4">Kitap Okuyun</h3>
              <p className="text-gray-600">
                Belirlenen girişimcilik kitabını okuyarak kendinizi geliştirin ve yarışmaya hazırlanın.
              </p>
            </Card>

            <Card className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-text-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4">Sınava Katılın</h3>
              <p className="text-gray-600">
                20.06.2026 tarihinde düzenlenecek sınavda bilginizi test edin ve başarınızı gösterin.
              </p>
            </Card>

            <Card className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-trophy-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4">Ödül Kazanın</h3>
              <p className="text-gray-600">
                1.000 kişiye dağıtılacak toplam 5 Milyon TL değerindeki ödüllerden birine sahip olun.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Book Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/4fb6cdc11f79cfa6cbb5a2aebb33267c.png"
                alt="Motivasyon Gücüyle Girişimcilik Rehberi Kitabı"
                className="w-full max-w-md mx-auto rounded-lg shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                Okunacak Kitap
              </h2>
              <h3 className="text-2xl font-semibold text-yellow-600 mb-4">
                "Motivasyon Gücüyle Girişimcilik Rehberi"
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Bu kitap, girişimcilik dünyasına adım atmak isteyen genç profesyoneller ve üniversite öğrencileri için 
                hazırlanmış kapsamlı bir rehberdir. Motivasyon, vizyon, strateji ve başarı konularında 
                derinlemesine bilgi edineceksiniz.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Girişimcilik temelleri ve motivasyon teknikleri</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Vizyon oluşturma ve hedef belirleme stratejileri</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Başarı hikayeleri ve pratik uygulamalar</span>
                </div>
              </div>
              <Link to="/competition">
                <Button size="lg">
                  <i className="ri-information-line mr-2"></i>
                  Kitap Detayları
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Prizes Preview */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Muhteşem Ödüller
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Toplam 5 Milyon TL değerinde 1.000 kişiye verilecek ödüller sizi bekliyor!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl p-6 text-center text-gray-900">
              <i className="ri-car-line text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Togg Araba</h3>
              <p className="text-sm">1.440.000 TL Değerinde</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-money-dollar-circle-line text-4xl text-yellow-400 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Nakit Ödüller</h3>
              <p className="text-sm text-gray-300">700.000 TL'ye kadar</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-motorbike-line text-4xl text-yellow-400 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Elektrikli Motosiklet</h3>
              <p className="text-sm text-gray-300">3 Adet</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-gamepad-line text-4xl text-yellow-400 mb-4"></i>
              <h3 className="text-lg font-bold mb-2">PlayStation 5</h3>
              <p className="text-sm text-gray-300">Ve daha fazlası...</p>
            </div>
          </div>

          <div className="text-center">
            <Link to="/prizes">
              <Button variant="primary" size="lg">
                <i className="ri-gift-line mr-2"></i>
                Tüm Ödülleri Görüntüle
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-400 to-yellow-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Yarışmaya Katılmaya Hazır mısınız?
          </h2>
          <p className="text-xl text-gray-800 mb-8">
            Kayıt için son tarih: 07 Haziran 2026
          </p>
          <div className="flex flex-col sm-flex-row gap-4 justify-center">
            <Link to="/register">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto">
                <i className="ri-user-add-line mr-2"></i>
                Hemen Kayıt Ol
              </Button>
            </Link>
            <Link to="/competition">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white">
                <i className="ri-information-line mr-2"></i>
                Detaylı Bilgi Al
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
